import ModelFactory from 'business/models/ModelFactory';
import {
  FragmentClient,
  FragmentFragmentScreenDTO,
  FragmentScreenDTO,
  FragmentScreenViewItemsDTO,
  IFragmentFragmentScreenDTO,
  SaveFragmentScreenViewDTO,
  SaveFragmentScreenViewResultDTO,
  FragmentScreenTreeNodeInfoDTO,
} from 'business/models/Models';

import BaseService from 'business/services/BaseService';

export default class FragmentService extends BaseService {
  async getFragmentScreen(fragmentScreenId: number): Promise<FragmentScreenViewItemsDTO> {
    const fragment: FragmentClient = ModelFactory(FragmentClient, false, true);
    const result = await fragment.getFragmentScreenView(fragmentScreenId);
    return result;
  }

  async CreateFragmentScreen(
    createFragmentScreenDTO: FragmentScreenDTO,
  ): Promise<FragmentScreenDTO> {
    const fragment: FragmentClient = ModelFactory(FragmentClient, false, true);
    const result = await fragment.createFragmentScreen(createFragmentScreenDTO);
    return result;
  }

  async SaveFragmentScreenView(
    saveFragmentScreenViewDTO: SaveFragmentScreenViewDTO,
  ): Promise<SaveFragmentScreenViewResultDTO> {
    const fragment: FragmentClient = ModelFactory(FragmentClient, false, true);
    const result = await fragment.save(saveFragmentScreenViewDTO);
    return result;
  }

  async getFragmentScreenCount(
    fragmentScreenId: number,
  ): Promise<FragmentScreenTreeNodeInfoDTO> {
    const fragment: FragmentClient = ModelFactory(FragmentClient, false, true);
    const result = await fragment.getFragmentScreenCount(fragmentScreenId);
    return result;
  }

  async getFragmentsInfo(ids: IFragmentFragmentScreenDTO[]) {
    const fragment: FragmentClient = ModelFactory(FragmentClient, false, true);
    const idsList = ids
      .filter((id) => id.fragmentId != null && id.fragmentScreenId != null)
      .map((id) => new FragmentFragmentScreenDTO({ ...id }));
    const result = await fragment.getFragmentInfo(idsList);
    return result;
  }

  async getFragmentScreenData(id: number) {
    const fragment: FragmentClient = ModelFactory(FragmentClient, false, true);
    const result = await fragment.getFragmentScreen(id);
    return result;
  }
}
